import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Nav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const nav = (content && content.nav) || [];
        const limit = content && content.limit ? content.limit : 18;

        return (
            <React.Fragment>
                <ul key="nav" className={styles.list_menu}>
                    {nav.slice(0, limit).map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
                {nav.length > limit ? (
                    <div key="navMore" className={styles.morehNew}>
                        <div>
                            <a href="javascript:;">更多</a>
                            <ul className={styles.more}>
                                {nav.slice(limit).map((item, index) => (
                                    <li key={index}>
                                        <a href={item.url} target="_blank">
                                            {item.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ) : null}
            </React.Fragment>
        );
    }
}

export default errorBoundary(Nav);
